import { helpers } from "../../../../packages/helpers";
import type { Person } from "../../../../packages/types";
import type { AuthResponse } from "../../types";

const { getStringValue } = helpers.text;

type Return = {
  user: Person;
  access: {
    token: string;
    expired: number;
  };
};

const getUserData = (data: unknown): Return => {
  const res = data as AuthResponse;

  return {
    user: {
      id: getStringValue(res?.data?.id),
      name: {
        first: getStringValue(res?.data?.passport?.lastName),
        last: getStringValue(res?.data?.passport?.firstName),
        middle: getStringValue(res?.data?.passport?.middleName),
      },
    },
    access: {
      token: getStringValue(res?.data?.session?.access?.token),
      expired: res?.data?.session?.access?.exp || 0,
    },
  };
};

export { getUserData };
